import Vue from 'vue'
import Vuex from 'vuex'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { pwdLogin,getInfo,uuidLogin,unRegist } from '@/api/login'
Vue.use(Vuex)
const Token = JSON.parse(localStorage.getItem('vue_Access-Token'))
const Info = JSON.parse(localStorage.getItem('vue_USERINFO'))
export default new Vuex.Store({
  state: {
    token: Token ? Token.value : '',
    info: Info ? Info.value : {},
    isLogin: Token === null ? false : true
  },
  getters: {
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
      state.isLogin = token?true:false
      Vue.ls.set(ACCESS_TOKEN, token, 8 * 60 * 60 * 1000)
    },
    SET_INFO: (state, info) => {
      state.info = info
      Vue.ls.set('USERINFO', info)
    },
  },
  actions: {
    // 账号登录
    UserLogin({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        if (userInfo.loginType === 'pwdLogin') {
          pwdLogin(userInfo).then(response => {
            const result = response.datas
            commit('SET_TOKEN', result.access_token)
            resolve()
          }).catch(error => {
            reject(error)
          })
        }else if (userInfo.loginType === 'uuidLogin') {
          uuidLogin(userInfo).then(response => {
            const result = response.datas
            commit('SET_TOKEN', result.access_token)
            resolve()
          }).catch(error => {
            reject(error)
          })
        }
      })
    },
     // 获取用户信息
        GetInfo ({ commit },userInfo) {
          return new Promise((resolve, reject) => {
            getInfo(userInfo).then(response => {
              const result = response.datas
              commit('SET_INFO', result)
              resolve(response)
            }).catch(error => {
              reject(error)
            })
          })
        },
    // 登出
    UserLogout({ commit, }) {
      return new Promise((resolve,) => {
        commit('SET_TOKEN', '')
        Vue.ls.remove(ACCESS_TOKEN)
        resolve()
      })
    },
    // 注销账号
    UserOff({ dispatch}) {
      return new Promise((resolve) => {
        unRegist().then(() => {
             dispatch('Clear').then(() => {
              resolve()
          })
        })
      })
    },
    // 清除
    Clear({ commit }) {
      return new Promise((resolve) => {
        commit('SET_TOKEN', '')
        Vue.ls.remove(ACCESS_TOKEN)
        console.log(this.state.isLogin,'----------');
        resolve()
      })
    }
  },
  modules: {
  }
})
